"use client";

import React from "react";
import { Github, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const productLinks = [{
  label: "The Experience",
  href: "/Experience"
}, {
  label: "Global Gatherings",
  href: "/GlobalGatherings"
}, {
  label: "The Shop",
  href: "/Shop"
}, {
  label: "Rituals",
  href: "#"
}];
const socialLinks = [{
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Github,
  href: "#",
  label: "GitHub"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted/10 animate-pulse" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm font-default opacity-50 hover:opacity-100 hover:text-primary transition-all duration-300 tracking-wide">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return;
}